module.exports = __webpack_public_path__ + "77032c78ff4c8e846f79602d5985448d.png";